// Canvas backdrop fills, keyed by the 'editor.background' preference value
// (settings-menu View flyout → ControlsTopLeft.jsx, persisted via
// preferencesPatchRequest). Single source of truth shared by the live
// canvas backdrop (Canvas.jsx paints it as a CSS background behind #canvas /
// #canvas-g) and the exported PNG's backdrop fill (downloadCanvasImageNew),
// so the two stay pixel-identical. Same shape/spirit as noteColors.js's
// NOTE_BODY_COLORS — a plain named map + accessor with a default fallback.
//
// 'default' is EXACTLY the app's original hardcoded canvas backdrop
// (index.scss .App.dark-mode --body-background: #3a495a) — do not change
// this value, it IS "today's" look. The rest are muted dark tints at
// roughly the same lightness so none of them reads as garish against
// table/note content, while staying clearly distinguishable from each
// other and from 'default'. The user hand-tunes these constantly — keep
// this map (and only this map) as the place to tweak a shade.
export const CANVAS_BACKGROUND_COLORS = {
    // default: 'rgb(15, 16, 16)', // unchanged original backdrop — do not edit
    default: 'rgb(16, 17, 17)', // unchanged original backdrop — do not edit
    gray: 'rgb(20, 21, 21)', // unchanged original backdrop — do not edit
    blue: 'rgb(18, 18, 26)', // unchanged original backdrop — do not edit
    purple: 'rgb(22, 17, 27)', // unchanged original backdrop — do not edit
    violet: 'rgb(24, 17, 24)', // unchanged original backdrop — do not edit
    green: 'rgb(14, 20, 14)', // unchanged original backdrop — do not edit
    red: 'rgb(22, 16, 16)', // unchanged original backdrop — do not edit
    yellow: 'rgb(23, 23, 17)', // unchanged original backdrop — do not edit
};

// 'none'/undefined/unrecognized values resolve to `default`.
export const canvasBackgroundColor = (value) => CANVAS_BACKGROUND_COLORS[value] || CANVAS_BACKGROUND_COLORS.default;
